import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var deferred = function deferred() {
  var resolve = null;
  var promise = new Promise(function (res) {
    resolve = res;
  });
  return [promise, resolve];
};
export var useStripePromise = function useStripePromise(stripe) {
  var _useState = useState(function () {
      return deferred();
    }),
    _useState2 = _slicedToArray(_useState, 1),
    _useState2$ = _slicedToArray(_useState2[0], 2),
    stripePromise = _useState2$[0],
    resolve = _useState2$[1];
  useEffect(function () {
    if (stripe) {
      resolve(stripe);
    }
  }, [resolve, stripe]);
  return stripePromise;
};